import { Box, Button, Card, CardActionArea, CardActions, CardContent, CardHeader, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, styled } from "@mui/material";
import { DataField, DataOutput, DataRow, DropdownModel, EditorType, TableInfo } from "../../../data/interfaces/sharedmodels";
import { useCallback, useEffect, useState } from "react";
import bulkimportService from "../../../data/api/bulkimport.service";
import { Delete, Download, Edit } from "@mui/icons-material";
import { formatValueForApi } from "../../../shared/commonfunctions";
import MergeGroupField from "../../../shared/datamanagementcomponents/mergegroupfield";
import EditableField from "../../../shared/datamanagementcomponents/editabledatatablefield";
import { useAppDispatch } from "../../../stores/hooks";
import { showsuccessmessage, showwarningmessage } from "../../../stores/notificationslice";




const BulkImportHeader = ({ table }: { table: TableInfo }) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h6">{table.Description}</Typography>
            {/* <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<Download />}
            >
                Import
                <VisuallyHiddenInput type="file" onChange={handleFileChange} />
            </Button> */}
        </Box>
    )
}


export default function BulkImportEditableDatatables({ table, tocs }: { table: TableInfo, tocs: DropdownModel[] }) {
    const dispatch = useAppDispatch();
    const [data, setData] = useState<DataOutput>({
        TableId: 0, Fields: [], Rows: [],
        FieldLookups: [], CanAddRows: true, CanDeleteRows: true, Version: '0.0.0', IsEditable: true, ReadOnlyUser: false
    });
    const [tempId, setTempId] = useState(-999);
    useEffect(() => {
        if (table && tocs.length && (data.TableId == 0 || table.Id != data.TableId)) {
            bulkimportService.getSchema(table.Id, tocs[0].Id).then((response) => {
                setData(response.data);
            })
        }
    }, [table, tocs]);

    const addRow = () => {
        let tempData = { ...data };
        setTempId(tempId + 1)
        let tempRow: DataRow = { Attributes: [], UniqueIdValue: tempId, OldUniqueId: null, IsDeleted: false };
        tempData.Fields.forEach(field => {
            tempRow.Attributes.push({ Name: field.Name, Value: field.IsMultiSelect ? [] : formatValueForApi(null, field.Type, field.IsNullable) })
        });
        tempData.Rows.push(tempRow);
        setData(tempData);
    }

    const deleteRow = (index: number) => {
        //row.IsDeleted = true;
        let tempData = { ...data };
        tempData.Rows.splice(index, 1);
        setData(tempData);
    }

    const handleValueChange = useCallback((field: DataField, uniqueId: any, newValue: any) => {

        let existData = { ...data };
        existData.Rows.filter(a => a.UniqueIdValue == uniqueId)[0].Attributes.filter(a => a.Name == field.Name)[0].Value = newValue;
        setData(existData);

    }, [data]);

    const handleSave = () => {
        const updateInput = { TocIds: tocs.flatMap(a=>a.Id) , InputData: data };
        bulkimportService.updateTableData(updateInput).then((response)=>{
            if (response&& response.data) {
                dispatch(showsuccessmessage("The data is saved successfully."))
            }
        });
    }

    return (
        <Card sx={{ p:1,pt:0}}>
            <CardHeader  title={<BulkImportHeader table={table} />} />
            <CardContent>
                {table?.Id && data ?
                    <TableContainer sx={{ width: '100%' }}>
                        <Table>
                        <TableHead>
                            <TableRow>
                                {data.Fields.filter(a => a.IsBrowsable).map((field) => {
                                    return (
                                        <TableCell
                                            sx={{ minWidth: '400px' }}
                                            align="center"
                                            key={field.Name}
                                        >
                                            {field.Description}

                                        </TableCell>
                                    )

                                })}
                                {data.Fields.length ? <TableCell width={1} align="center">Delete</TableCell> : null}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.Rows.length<1?<Typography sx={{p:1}}>Click 'Add More' button to add rows to the selected table</Typography>:null}
                            {data.Rows.map((row, index) => {
                                return (

                                    <TableRow
                                        key={row.UniqueIdValue}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >

                                        {
                                            data.Fields.filter(a => a.IsBrowsable).map((field) => {
                                                let attField = data.Fields.filter(a => a.Name == field.Name)[0];
                                                if (attField.ToggleField && row.Attributes.filter(a => a.Name == attField.ToggleField)[0].Value == attField.ToggleCondition) {

                                                    return (<TableCell key={field.Name + row.UniqueIdValue} sx={{ textAlign: 'center' }}>-</TableCell>)
                                                }
                                                else if (attField.MergeGroup != null) {

                                                    let mergedFields = data.Fields.filter(f => f.MergeGroup === attField.MergeGroup);



                                                    let values = mergedFields.map(f => row.Attributes.find(a => a.Name === f.Name));

                                                    if (field === mergedFields[0]) {

                                                        return (
                                                            <TableCell key={field.Name + row.UniqueIdValue}>
                                                                <MergeGroupField title={field.MergeGroup} mergeFields={mergedFields} values={values || []} key={field.Name + row.UniqueIdValue} uniqueIdValue={row.UniqueIdValue} callback={handleValueChange} ></MergeGroupField>
                                                            </TableCell>
                                                        );
                                                    } else {

                                                        return null;
                                                    }
                                                }
                                                else {
                                                    return (
                                                        <Tooltip title={field.ToolTip}>
                                                            <TableCell>
                                                                <EditableField width={120} isEditable={true} key={field.Name + row.UniqueIdValue} field={field} value={row.Attributes.filter(a => a.Name == field.Name)[0].Value}
                                                                    uniqueId={row.UniqueIdValue} callback={handleValueChange}
                                                                    fieldLookups={data.FieldLookups.findIndex(a => a.FieldName == field.Name) > -1 ?
                                                                        data.FieldLookups[data.FieldLookups.findIndex(a => a.FieldName == field.Name)].LookUpValues : undefined} /></TableCell></Tooltip>
                                                    )
                                                }
                                            })
                                        }
                                        <TableCell width={1} align="center"><IconButton onClick={() => deleteRow(index)}><Delete /></IconButton></TableCell>
                                    </TableRow>
                                )
                            })
                            }
                        </TableBody>
                        </Table>
                    </TableContainer>

                    : null}

            </CardContent>
            <CardActions>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', m: 1,width:'100%' }}>
                    {data && data.Fields.length && (table.MaxRowCount == null || data.Rows.length < table.MaxRowCount) ?
                        <Button  variant="outlined" onClick={addRow}>Add More</Button> : null}
                    {data && data.Rows.length&&tocs.length ?
                        <Button variant="contained" onClick={handleSave}>Save</Button> : null}
                </Box>
            </CardActions>
        </Card>
    )
}